import React, { Component } from "react"
import PropTypes from "prop-types"
import Modal from "../../Modal"
import "./image.scss"

class Image extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      isModalOpen: false,
    }
  }

  handelCloseModal = () => {
    this.imageTrackEvent()

    this.setState((prevState) => {
      return { isModalOpen: !prevState.isModalOpen }
    })
  }

  renderImage = () => {
    const { description, uri, isPopup, imageLinkURL } = this.props

    if (isPopup && !imageLinkURL.trim()) {
      return (
        <div>
          <div className="image-component__icon">
            <i className="glyphicon glyphicon-new-window " />
          </div>
          <img
            className={`image-component__image ${isPopup ? "poup-image" : ""}`}
            src={uri}
            alt={description}
            onClick={this.handelCloseModal}
          />
        </div>
      )
    } else {
      return (
        <div>
          <div className="image-component__icon">
            <i className="glyphicon glyphicon-link" />
          </div>
          <a target="_blank" onClick={this.handleLinkEvent}>
            <img
              className={`image-component__image`}
              src={uri}
              alt={description}
            />
          </a>
        </div>
      )
    }
  }

  imageTrackEvent = () => {
    let { articleSlug, data, uri, imageLinkURL } = this.props
    /**
     * [images description]
     * filter components to get only the image components
     */
    let images = data.page.postComponents.filter((item, index) => {
      if (item.type === "image-upload-component") return item
    })

    /**
     * [imageLocation description]
     * find the index of the image that was clicked
     */
    let imageLocation = images.findIndex((component) => {
      return component.props.uri === this.props.uri ? true : false
    })

    this.props.trackEvent("Image Component", {
      articleSlug: articleSlug,
      imageUri: uri,
      imageComponent: imageLocation + 1,
      imageLinkURL: imageLinkURL.trim() ? imageLinkURL : "Modal Image",
    })
  }

  handleLinkEvent = (e) => {
    e.preventDefault()

    this.imageTrackEvent()
    window.open(this.props.imageLinkURL, "_blank")
  }

  render() {
    const { description, uri, isPopup, imageLinkURL } = this.props
    const { isModalOpen } = this.state

    return (
      <figure className="image-component">
        {this.renderImage()}
        {description && (
          <figcaption className="image-component__caption">
            <span className="image-component__caption--light">
              Image Credit:
            </span>{" "}
            {description}
          </figcaption>
        )}
        {isPopup && !imageLinkURL.trim() && (
          <Modal
            isOpen={isModalOpen}
            closeIcon={true}
            close={this.handelCloseModal}
            classes={["image-modal"]}
          >
            <img className="image-modal__image" src={uri} alt={description} />
          </Modal>
        )}
      </figure>
    )
  }
}

Image.propTypes = {
  description: PropTypes.string,
  uri: PropTypes.string,
  isPopup: PropTypes.bool,
}
Image.defaultProps = {
  isPopup: true,
  imageLinkURL: "",
}
export default Image
